(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-years"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    deferSwiper(function() {
      const timelineSwiper = new Swiper('.timeline__list', {
        slidesPerView: 1,
      });

      const timelinePaginationItems = document.querySelectorAll('.timeline__pagination-item');
      timelinePaginationItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          timelineSwiper.slideTo(index);
        });
      });

      timelinePaginationItems[0].classList.add('active');

      timelineSwiper.on('slideChange', () => {
        timelinePaginationItems.forEach((item, index) => {
          if (index === timelineSwiper.activeIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1140px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + "px");
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const MAX_SLIDES_PER_VIEW_DESKTOP = 8;
    const MAX_SLIDES_PER_VIEW_TABLET = 4;
    const MAX_SLIDES_PER_VIEW_MOBILE = 2;

    const collectionList = document.querySelector('.shop-by-category__collections');
    const collectionLength = collectionList.getAttribute('data-collection-size');

    let swiperSlidesPerViewDesktop = collectionLength;
    let swiperSlidesPerViewTablet = collectionLength;
    let swiperSlidesPerViewMobile = collectionLength;

    if (collectionLength > MAX_SLIDES_PER_VIEW_DESKTOP) {
      swiperSlidesPerViewDesktop = MAX_SLIDES_PER_VIEW_DESKTOP + 0.5;
    }

    if (collectionLength > MAX_SLIDES_PER_VIEW_TABLET) {
      swiperSlidesPerViewTablet = MAX_SLIDES_PER_VIEW_TABLET + 0.5;
    }

    if (collectionLength > MAX_SLIDES_PER_VIEW_MOBILE) {
      swiperSlidesPerViewMobile = MAX_SLIDES_PER_VIEW_MOBILE + 0.5;
    }

    deferSwiper(function() {
      const swiper = new Swiper(collectionList, {
        spaceBetween: 15,
        breakpoints: {
          320: {
            slidesPerView: swiperSlidesPerViewMobile,
          },
          768: {
            slidesPerView: swiperSlidesPerViewTablet,
          },
          1024: {
            slidesPerView: swiperSlidesPerViewDesktop,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
